module.exports = __webpack_public_path__ + "static/media/alarm-outline-small.eddabf7b.svg";